// User Vietnamese translations
export const userVi = {
  'add.driver': 'Thêm Tài Xế',
  'add.user': 'Thêm Người Dùng',
  'are.you.sure.you.want.to.delete.this.user': 'Bạn có chắc chắn muốn xóa người dùng này không?',
  'current.default.driver.salary.rate': 'Tỷ Lệ Lương Tài Xế Mặc Định Hiện Tại',
  'default.driver.salary.rate': 'Tỷ Lệ Lương Tài Xế Mặc Định',
  'driver': 'Tài Xế',
  'driver.created.successfully': 'Tạo tài xế thành công',
  'driver.deleted.successfully': 'Xóa tài xế thành công',
  'driver.details': 'Chi Tiết Tài Xế',
  'driver.management': 'Quản Lý Tài Xế',
  'driver.name': 'Tên Tài Xế',
  'driver.phone': 'Số Điện Thoại Tài Xế',
  'driver.salary': 'Lương Tài Xế',
  'driver.updated.successfully': 'Cập nhật tài xế thành công',
  'drivers': 'Tài Xế',
  'edit.driver': 'Chỉnh Sửa Tài Xế',
  'edit.user': 'Chỉnh Sửa Người Dùng',
  'error.creating.driver': 'Lỗi khi tạo tài xế',
  'error.deleting.driver': 'Lỗi khi xóa tài xế',
  'error.fetching.drivers': 'Lỗi khi tải danh sách tài xế',
  'error.updating.driver': 'Lỗi khi cập nhật tài xế',
  'failed.to.create.driver': 'Không thể tạo tài xế',
  'failed.to.delete.driver': 'Không thể xóa tài xế',
  'failed.to.fetch.drivers': 'Không thể tải danh sách tài xế',
  'failed.to.update.driver': 'Không thể cập nhật tài xế',
  'role': 'Vai Trò',
  'salary.rate': 'Tỷ lệ lương',
  'total.drivers': 'Tổng Số Tài Xế',
  'update.driver.rate': 'Cập Nhật Tỷ Lệ Lương Tài Xế',
  'user': 'Người Dùng',
  'user.details': 'Chi Tiết Người Dùng',
  'user.management': 'Quản Lý Người Dùng',
  'username': 'Tên Đăng Nhập',
  'users': 'Người Dùng',
  'users.involved': 'Người Dùng Liên Quan',
};
